import { render, staticRenderFns } from "./BirthDateAutoInputFields.vue?vue&type=template&id=f6b77502&scoped=true"
import script from "./BirthDateAutoInputFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./BirthDateAutoInputFields.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BirthDateAutoInputFields.vue?vue&type=style&index=0&id=f6b77502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b77502",
  null
  
)

export default component.exports